import React from 'react'
import { Box } from '@mui/material'
import Header from 'components/Header'

const Dashboard = () => {
  return (
    <Box
      padding={2}>
      <Header title='Dashboard' />
    </Box>
  )
}

export default Dashboard